import { Injectable } from '@angular/core';
import { Devicetype, WindowSize } from '../models/imports/generic';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { distinctUntilChanged,map } from 'rxjs/operators';
import { mapTo } from 'rxjs/operators';

function _window(): Window {
  // return the global native browser window object
  return window;
}

const mobilePortraitWidth = 576;
const mobileLandscapeWidth = 720;
const tabletPortraitWidth = 940;
const tabletLandscapeWidth = 1140;

@Injectable()
export class WindowService {
  windowSizes$: Observable<WindowSize>;
  deviceType$: Observable<Devicetype>;

  // Create more Observables as and when needed for various properties
  constructor() {
    const windowSize$ = new BehaviorSubject(this.getWindowSize());
    this.windowSizes$ = windowSize$.pipe(distinctUntilChanged());
    this.deviceType$ = this.windowSizes$.pipe(
      mapTo(this.deviceType()),
      distinctUntilChanged()
    )

    fromEvent(window, 'resize')
      .pipe(map(this.getWindowSize))
      .subscribe(windowSize$);
  }

  getWindowSize(): WindowSize {
    return new WindowSize(window.innerHeight, window.innerWidth);
  }

  get nativeWindow(): Window {
    return _window();
  }

  deviceType(): Devicetype {
    const screenWidth = this.nativeWindow.innerWidth;
    if (screenWidth < mobilePortraitWidth) {
      return Devicetype.MobilePortrait;
    }

    if ((screenWidth >= mobilePortraitWidth) && (screenWidth < mobileLandscapeWidth)) {
      return Devicetype.MobileLandscape;
    }

    if ((screenWidth >= mobileLandscapeWidth) && (screenWidth < tabletPortraitWidth)) {
      return Devicetype.TabletPortrait;
    }

    if ((screenWidth >= tabletPortraitWidth) && (screenWidth < tabletLandscapeWidth)) {
      return Devicetype.TabletLandscape;
    }

    return Devicetype.Desktop;
  }
}
